// tutorial: превод на редовете на функцията за превод $t
// превод на съобщенията за грешка за vee-validate
const bg = {
    'countryCode': 'bg_bg',
    'Accetto il regolamento fidelity e la privacy policy': 'Приемам правилата за лоялност и политиката за поверителност',
    'Account creation': 'Създаване на акаунт',
    'Add address': 'Добави адрес',
    'Address': 'Адрес',
    'Address label': 'Име адрес',
    'Address label placeholder': 'например: домашен, служебен...',
    'Amount': 'Стойност',
    'Apply': 'Приложи',
    'Apply Discount': 'Приложи отстъпка',
    'Are you sure you want to delete this item from cart': 'Наистина ли искате да изтриете този артикул от количката?',
    'Are you sure you want to move this item to wishlist?': 'Сигурни ли сте, че искате да преместите този артикул в списъка с желани ?',
    'articles': 'артикули',
    'articles inside': 'налични артикули',
    'Back': 'Назад',
    'Back to cart': 'Обратно в количката',
    'Back to shopping': 'Обратно към пазаруване',
    'Back to store': 'Обратно към магазина',
    'Billing address': 'Адрес за фактуриране',
    'Billing address is the same as the shipping address': 'Данните за фактура и доставка съвпадат',
    'Buy': 'Купи',
    'Buy Now': 'Купи сега',
    'Buy now, pay later': 'Купете сега, платете по-късно',
    'Cancel': 'Отмени',
    'Cannot apply Gift Card': 'Не може да се прилага карта за подарък',
    'Cannot apply glam card points': 'Не беше възможно да се приложат точки в твоята WE Card',
    'Card issuer authentication failed': 'Удостоверяването на издателя на картата е неуспешно',
    'Cart': 'Количка',
    'Cart content': 'Съдържание на количката',
    'Change': 'Смени',
    'Change address': 'Смени адреса',
    'Change e-mail': 'Смени имейл',
    'Change pickup point': 'Променете точката на вземане',
    'Check zip code': 'Проверете пощенския код',
    'Choose a shipping method in order to proceed': 'За да продължите, изберете начин на доставка',
    'Choose a store for the pick-up in order to proceed': 'Изберете магазин за вземане, за да продължите',
    'Choose a zipcode in order to proceed': 'Изберете пощенски код, за да продължите',
    'City': 'Град',
    'Close': 'Затвори',
    'Closed': 'Затворено',
    'Color': 'Цвят',
    'Complete your order': 'Завърши поръчката',
    'Condizioni di vendita': 'Условия за продажба',
    'Confirm': 'Потвърди',
    'Continue': 'Напред',
    'Continue as guest': 'Продължи като Гост',
    'Country': 'Страна',
    'Coupon': 'Ваучер',
    'Coupon Code': 'Код за отстъпка',
    'Credit Card': 'Кредитна карта',
    'Credit Card Number': 'Номер на картата',
    'data': 'данни',
    'Date of birth': 'Дата на раждане',
    'Date of Birth': 'Дата на раждане',
    'dd/mm/yyyy': 'дд/мм/гггг',
    'Delete': 'Изтрий',
    'Delivery:': 'Доставка:',
    'Description': 'Описание',
    'Do you have a discount code?': 'Имате код за отстъпка?',
    'Enter your Gift Card here': 'Въведете тук подаръчната си карта',
    'do-login': 'Впишете се',
    'done': 'Свършен',
    'E-mail address': 'Имейл',
    'Edit': 'Редактирай',
    'Edit address': 'Редактиране на адрес',
    'Edit Cart': 'Редактирай количката',
    'Email': 'Имейл',
    'Email and telephone number': 'Имейл и телефонен номер',
    'email-remainder': 'Изпратихме ви имейл за подновяване на паролата. Щракнете на връзката, която ще намерите в имейла.',
    'Empty credit card fields': 'Моля, попълнете данните за кредитната карта',
    'Enter shipping address': 'Въведете адрес за доставка',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Error during payment authorization': 'Грешка по време на потвърждението на плащането',
    'Error during registration': 'Грешка по време на регистрацията',
    'Error occurred while placing orde': 'Възникна грешка при поставянето на поръчката',
    'Expire Date': 'Валидност',
    'Female': 'Жена',
    'Firstname': 'Име',
    'Forgot your password?': 'Забравена парола?',
    'Free': 'Безплатно',
    'Friday': 'Петък',
    'From': 'От',
    'Gender': 'Пол',
    'Gift Card': 'Карта подарък',
    'Gift card and discount codes': 'Карта за подарък и кодове за отстъпка',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Отстъпка с бонус WE Card',
    'glamcard-bonusapplied': 'Приложени {bonus} точки в твоята WE Card',
    'Go to checkout': 'Отиди към плащане',
    'Go to payment': 'Към плащане',
    'Go to shipping': 'Отидете на доставка',
    'Go to summary': 'Отидете на резюме',
    'Home delivery cost': 'Цена на доставка в дома',
    'How many points do you want to use?': 'Колко бонус точки искате да използвате?',
    'How much bonus do you want to use?': 'Колко точки искате да използвате?',
    'I don\'t want to receive the invoice': 'Не искам да получавам фактура',
    'I want to receive the invoice': 'Искам да получа фактура',
    'Identical to shipping address': 'Идентичен с адреса за доставка',
    'Insert here coupon code': 'Въведи тук кода за отстъпка',
    'Insert here the shipping data': 'Въведи тук данните за доставка',
    'Insert here your email to proceed, we will send you just the order updates': 'Въведете вашия имейл, за да продължите, ще изпращаме само информация, свързана с тази поръчка',
    'Insert your billing address': 'Въведете вашия адрес за фактуриране',
    'invoice': 'плащане',
    'Invoice address': 'Адрес за фактуриране',
    'Last name': 'Фамилия',
    'Lastname': 'Фамилия',
    'Leave': 'Излез',
    'Loading': 'Зареждане',
    'Loading payment form, please wait': 'Зарежда се формуляра за плащане, моля изчакайте',
    'Login': 'Вход',
    'Male': 'Мъж',
    'Message': 'Съобщение',
    'Mobile phone': 'Телефонен номер',
    'Monday': 'Понеделник',
    'Move item': 'Премести артикул',
    'Move product': 'Преместване на продукта',
    'Name': 'Име',
    'New address': 'Нов адрес',
    'New client': 'Нов клиент',
    'No items in cart': 'Количката е празна',
    'No near stores': 'Няма близо до магазини',
    'No shipping methods available': 'Няма налични начини за доставка',
    'Not registered yet?': 'Все още нямате регистрация?',
    'Ok': 'Ок',
    'Or': 'Или',
    'Order detail': 'Подробности за поръчката',
    'Order details': 'Подробности за поръчката',
    'Order placed': 'Поръчката е направена. Ще бъдете пренасочени към страницата с резюме',
    'Order will be shipped to': 'Поръчката ще бъде доставена на',
    'Our online shop handles payments in Euros.<br> You will then be charged the amount of:': 'Плащането в нашия онлайн магазин се извършва в евро.<br> Следователно ще Ви бъде начислена сумата от:',
    'Password': 'Парола',
    'Password confirm': 'Потвърди паролата',
    'Pay': 'Плати',
    'payment': 'Плащане',
    'Payment': 'Плащане',
    'Payment error.': 'Грешка при плащане.',
    'Payment method': 'Начин на плащане',
    'Payment method not supported': 'Начинът на плащане не се поддържа',
    'Personal data': 'Лични данни',
    'Place of birth': 'Място на раждане',
    'Place of Birth': 'Място на раждане',
    'Please select shipping from Amazon widget': 'Моля, изберете доставка от изпълнимия модул на Amazon',
    'Please try again with another form of payment': 'Моля, опитайте отново с друг начин на плащане',
    'Please wait': 'Моля, изчакайте',
    'Please wait, payment is processing': 'Моля, изчакайте, плащането се обработва',
    'Postcode': 'Пощ.код',
    'Prefix': 'Префикс',
    'Proceed': 'Напред',
    'Proceed delete': 'Продължи',
    'Proceed to payment': 'Пристъпете към плащане',
    'Proceed with the purchase': 'Продължи с покупката',
    'product': 'продукти',
    'Product': 'Продукт',
    'products': 'продукти',
    'Products total': 'Общо продукти',
    'Quantity': 'Количество',
    'Register': 'Регистрирайте се',
    'Registered User': 'Регистриран потребител',
    'Registration agreement': 'Правила за регистрация',
    'Registration successful': 'Успешна регистрация',
    'registrationagreement': 'Приемам <a href="{linkfid}" target="_blank">правилата за лоялност</a> и <a href="{linkpriv}" target="_blank">политиката за поверителност</a>',
    'Remove': 'Премахни',
    'Remove Discount': 'Премахни отстъпка',
    'Remove the item': 'Премахни артикул',
    'Required fields': 'Задължителни полета',
    'Retry': 'Опитайте отново',
    'review': 'преглед',
    'Safe purchase': 'безопасна покупка',
    'Same as billing': 'Същият като за фактуриране',
    'Saturday': 'Събота',
    'Save': 'Запази',
    'Save address': 'Запази адреса',
    'Save in address book': 'Запази в адресната книга',
    'Save new address to proceed': 'Запазете нов адрес, за да продължите',
    'Select': 'Избери',
    'Select a city': 'Избери град',
    'Select a region': 'Избери регион',
    'Select an address': 'Изберете адрес',
    'Select here your shipping address': 'Избери тук адреса за доставка',
    'Select payment method': 'Избери начин на плащане',
    'Select region': 'Избери област',
    'Select shipping method': 'Избери начин на доставка',
    'Select store pickup': 'Изберете взимане от магазина',
    'Select store pickup to precede': 'Изберете магазин за вземане, за да продължите',
    'Select the store': 'Избери магазин',
    'Select this store': 'Изберете този магазин',
    'Select value': 'Избор на стойност',
    'Selected Store': 'Избран магазин',
    'Seleziona il metodo di spedizione': 'Избери начин на доставка',
    'Send remainder': 'Изпрати имейл за възстановяване на паролата',
    'Service unavailable, retry later': 'Временна грешка по време на заявката, опитайте по-късно',
    'Session expired, page will reload': 'Сесията изтече, страницата ще се презареди',
    'shipping': 'Доставка',
    'Shipping': 'Доставка',
    'Shipping address': 'Адрес за доставка',
    'Shipping and handling': 'Доставка и обработка',
    'Shipping data': 'Данни за доставка',
    'Shipping informations': 'Информация за доставка',
    'Shop opening hours': 'Работно време на магазинаs',
    'Shopping Cart': 'Количка',
    'shopping details': 'подробности за покупката',
    'Size': 'Размер',
    'Something went wrong during Yandex Checkout': 'Нещо се обърка по време на Yandex Checkout',
    'State/Region': 'Провинция',
    'Store selection': 'Избор на магазин',
    'street': 'улица',
    'Street': 'Улица',
    'Street number': 'Номер на улица',
    'Sunday': 'Неделя',
    'Surname': 'Фамилия',
    'Tax included': 'Включени данъци',
    'Telephone': 'Телефон',
    'Telephone number': 'Телефонен номер',
    'Telephone number for courier / store pickup': 'Телефон за получаване от куриер/магазин',
    'Terranova stores near you': 'Магазини Terranova близо до вас',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Ваучерът не е валиден. Проверете кода и опитайте отново.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'Подаръчната карта е невалидна или празна. Моля, проверете подаръчната карта и опитайте отново',
    'The maximum value of the usable We+Card bonus is': 'Максималната стойност на WE Card бонус, която може да се използва, е',
    'The maximum value of the usable WE+Card points is': 'Максималната стойност на използваемите точки от WE Card е',
    'The order is already been paid, please wait while order is placing': 'Поръчката вече е платена, моля изчакайте, докато се прави поръчката',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Паролата трябва да се състои от най-малко 8 символа и да съдържа главна, малка буква, число и специален символ (.;,!$#).',
    'The requested qty is not available': 'Заявеното количество не е налично',
    'There has been an error. Please try again': 'Възникна грешка. Моля, опитайте отново',
    'This email already esists. Do the login or proceed as guest': 'Този имейл вече съществува. Впишете се или продължете като гост',
    'This product is not available, please remove it from cart to proceed': 'Този продукт не е наличен, моля, премахнете го от количката, за да продължите',
    'Thursday': 'Четвъртък',
    'To': 'За',
    'Total': 'Общо',
    'Tuesday': 'Вторник',
    'Type of card': 'Тип карта',
    'Update address': 'Актуализиране на адреса',
    'Use Glam Card Bonus': 'Използвай Бонус WE Card',
    'Use points': 'Използвай бонус',
    'Use WE+ points': 'Използвайте точки от WE Card',
    'User': 'Потребител',
    'Valid until': 'валиден до',
    'VAT number': 'Данъчен номер',
    'Verify billing address': 'Потвърдете адреса за фактуриране',
    'Verify Gift Card': 'Потвърдете картата за подарък',
    'Verify payment method selection': 'Потвърдете избора на начин на плащане',
    'Verify shipping address': 'Потвърдете адреса за доставка',
    'Verify shipping method selection': 'Потвърдете избора на начин на доставка',
    'View your cart': 'Вижте количката',
    'Wait for page to reload': 'Изчакайте страницата да се презареди',
    'We\'re unable to send the password reset email': 'Не беше възможно изпращането на имейл за подновяване на паролата. Проверете въведения имейл',
    'Wednesday': 'Сряда',
    'You are ordering with this email address': 'Поръчваш с този имейл адрес',
    'You are shipping in a foreign country': 'Изпращате в чужда държава',
    'Your available points': 'Вашите налични точки',
    'Your avalaible bonus': 'Стойност на бонуса',
    'Zip code': 'пощ.код',
    'Zip or city': 'Пощенски код на града',
    'zipdigitwarnings': 'Warning the zip code should consist of {zipdigits} charachters',
    'Shipping cost excluded': 'Разходите за доставка не са включени',
    'Extra address': 'Допълнителна информация (по избор)',
    'Extra address placeholder': 'при, вътрешен номер, Район, име върху домофона',
    '8 characters': '8 знака',
    '1 lowercase letter': '1 малка буква',
    '1 uppercase letter': '1 главна буква',
    '1 number': '1 число',
    '1 special character': '1 специален знак',
    'Now you can use your points': 'Сега можете да използвате вашите точки',
    'Hallo': 'Здравей',
    'Save Credit Card (One Click Payment)': 'Запазване на кредитна карта (плащане с едно кликване)',
    'Pay with a saved credit card': 'Плащане със запазена кредитна карта',
    'Pay with a new credit or debit card': 'Плащане с нова кредитна или дебитна карта',
    'Expiration': 'Валидност',
    'Other': 'Друг',
    'Applied discounts': 'Приложени отстъпки',
    'Municipality': 'Община',
    'Choose size': 'Избор на размер',
    'amount-for-freeshipping': 'Не ви достигат {amount} за безплатна доставка с куриер\n',
    'To proceed you must select a payment method': 'За да продължите, трябва да изберете метод на плащане',
    'To proceed you need to save the selected billing address': 'За да продължите, трябва да запазите избрания адрес за фактуриране',
    'To proceed it is necessary to accept the general conditions of sale': 'За да продължите, е необходимо да приемете общите условия за продажба',
    'To proceed you need to select the store': 'За да продължите, трябва да изберете магазина',
    'To proceed you need to save your changes': 'За да продължите, трябва да запазите промените',
    'Are you sure you want to delete this address?': 'Наистина ли искате да изтриете този адрес?',
    'To proceed you need to save the selected shipping address': 'За да продължите, трябва да запазите избрания адрес за доставка',
    'message-double_optin_using_point_disabled': 'Не може да използвате точки за тази покупка, тъй като все още не сте потвърдили валидността на имейла или телефонния си номер. Ако имате въпроси, свържете се с нашия отдел за обслужване на клиенти.',
}
export default bg;
export const bgValidation = {
    name: "bg",
    messages: {
        _default: function (e: any) {
            return "стойността на полето " + e + " не е валидна."
        },
        after: function (e: any, n: any) {
            return "на " + e + " трябва да бъде след " + n[0] + "."
        },
        alpha: function (e: any) {
            return "полето " + e + " може да съдържа само букви."
        },
        alpha_dash: function (e: any) {
            return "полето " + e + " може да съдържа буквено-цифрени символи, както и тирета и долни черти."
        },
        alpha_num: function (e: any) {
            return "полето " + e + " може да съдържа само буквено-цифрени символи."
        },
        alpha_spaces: function (e: any) {
            return "полето " + e + " може да съдържа буквено-цифрени символи, както и интервали."
        },
        before: function (e: any, n: any) {
            return "полето " + e + " трябва да бъде преди " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "полето " + e + " трябва да е между " + n[0] + " и " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "полето " + e + " не съответства на " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "полето " + e + " не е валидно."
        },
        date_between: function (e: any, n: any) {
            return "Там " + e + " трябва да бъде между " + n[0] + " и " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "Там " + e + " трябва да е във формат " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "полето " + e + " трябва да е число и може да съдържа" + (r && "*" !== r ? " " + r : "") + " десетични запетаи."
        },
        digits: function (e: any, n: any) {
            return "полето " + e + " трябва да е число и да съдържа точно " + n[0] + " цифри."
        },
        dimensions: function (e: any, n: any) {
            return "полето " + e + " трябва да бъде " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "полето " + e + " трябва да бъде валиден имейл адрес."
        },
        excluded: function (e: any) {
            return "полето " + e + " трябва да има валидна стойност."
        },
        ext: function (e: any) {
            return "полето " + e + " трябва да бъде валиден файл."
        },
        image: function (e: any) {
            return "полето " + e + " трябва да бъде изображение."
        },
        included: function (e: any) {
            return "полето " + e + " трябва да има валидна стойност."
        },
        ip: function (e: any) {
            return "полето " + e + " трябва да бъде валиден IP адрес."
        },
        length: function (e: any, n: any) {
            return "дължината на полето " + e + " трябва да бъде " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "полето " + e + " не може да е по-дълго от " + n[0] + " символи."
        },
        max_value: function (e: any, n: any) {
            return "полето " + e + " трябва да бъде по-малко или равно на " + n[0]
        },
        mimes: function (e: any) {
            return "полето " + e + " трябва да има валиден тип на файл."
        },
        min: function (e: any, n: any) {
            return "полето " + e + " трябва да има най-малко " + n[0] + " символи."
        },
        min_value: function (e: any, n: any) {
            return "полето " + e + " трябва да бъде по-голямо или равно на " + n[0]
        },
        numeric: function (e: any) {
            return "полето " + e + " може да съдържа само цифри."
        },
        regex: function (e: any) {
            return "полето " + e + " няма валиден формат."
        },
        required: function (e: any) {
            return "полето " + e + " е задължително."
        },
        size: function (e: any, n: any) {
            return "полето " + e + " трябва да е по-малко от " + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "полето " + e + " не е валиден URL."
        },
        'validate-piva-cf': function (e: any) {
            return 'Невалиден ДДС номер/Данъчен номер.';
        },
        'validate-regionid': function (e: any) {
            return 'Полето Област е задължително.';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Street and street number fields must not exceed {2} charachters';
        },
        'validate-data-consensus': function(e: any) {
          return 'Вашето съгласие е необходимо за обработката на лични данни.';
        },
        'validate-gender': function(e: any) {
            return 'Полето Пол е задължително.';
        },
        'validate-password': function(e: any) {
            return 'Паролата трябва да се състои от най-малко 8 символа и да съдържа главна, малка буква, число и специален символ (.;,!$#).';
        },

    },
    attributes: {}
};
